import React from "react";
//*import PropTypes from 'prop-types';
import "./chatLeftSkeleton.scss";
import { URAvaratSkeleton } from "./skeletonWidgets/avatar";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
function URChatLeftSkeleton(props: any) {
  return (
    <>
      <div className="skeletonLoading">
        <div className="chatLeftSkeleton">
          <URAvaratSkeleton className='avatar sm'/>
          <div className="detailsList">
            <URLineSkeleton className='line lineThick size50'/>
            <URLineSkeleton className='line lineThin size75'/>
          </div>
          <div className="detailsListRight">
            <URLineSkeleton className='line lineThin size100'/>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URChatLeftSkeleton
};